module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-right.f0708eec.svg";